export * from "#words-frequency";
